class ChargeUnit {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'ChargeUnit'
const BOTTOM_PRICE = new ChargeUnit('最低价', '最低价')
const RT = new ChargeUnit('RT', 'RT')
const CBM = new ChargeUnit('CBM', 'CBM')
const TON = new ChargeUnit('TON', 'TON')

export const CHARGE_UNIT = [
  BOTTOM_PRICE,
  RT,
  CBM,
  TON
]
